<ion-header class="ion-no-border">

    <ion-toolbar>
        <ion-buttons slot="start">
            <ion-button (click)="close()">
                <fa-icon [icon]="['far', 'times']" size="lg" [fixedWidth]="true" slot="start"></fa-icon>
            </ion-button>
        </ion-buttons>
        <ion-title>
            Add refund
            <p *ngIf="order" class="subtitle">Order #{{order.number}}</p>
        </ion-title>
        <ion-buttons *ngIf="online && !loading" slot="end">
            <ion-button (click)="add()">
                <fa-icon [icon]="['far', 'check']" size="lg" [fixedWidth]="true" slot="start"></fa-icon>
            </ion-button>
        </ion-buttons>
    </ion-toolbar>

</ion-header>

<ion-content>

    <ion-grid *ngIf="online && !loading && order" class="form">
        <ion-row>
            <ion-col>
                <ion-grid class="fieldset">
                    <ion-row>
                        <ion-col>
                        <h3>Items to refund</h3>
                        </ion-col>
                    </ion-row>
                    <ion-row>
                        <ion-col>
                            <ion-grid class="ion-no-padding">
                                <ng-container *ngFor="let item of refundable_items">
                                    <ion-row *ngIf="item.refundable_quantity > 0" class="quantity-row ion-align-items-start">
                                        <ion-col>
                                            <ion-grid class="ion-no-padding">
                                                <ion-row>
                                                    <ion-col size="auto">
                                                        <h5>Item</h5>
                                                        <p class="prominent">{{item.title}}</p>
                                                    </ion-col>
                                                </ion-row>
                                                <ion-row *ngIf="item.sku">
                                                    <ion-col size="auto">
                                                        <h5>SKU</h5>
                                                        <p class="prominent">{{item.sku}}</p>
                                                    </ion-col>
                                                </ion-row>
                                            </ion-grid>
                                        </ion-col>
                                        
                                        <ion-col size="auto" class="ion-text-center">
                                            <div>
                                                <h5>Quantity<ng-container *ngIf="item.measurement_unit"> ({{item.measurement_unit.symbol}})</ng-container></h5>
                                                <fa-icon size="lg" [icon]="['far', 'minus']" (click)="adjustItemQuantity(item.id,'subtract')"></fa-icon><span>{{item.quantity}}</span> of {{item.refundable_quantity}}<fa-icon size="lg" [icon]="['far', 'plus']" (click)="adjustItemQuantity(item.id,'add')"></fa-icon>
                                            </div>
                                        </ion-col>

                                    </ion-row>
                                </ng-container>
                                <ion-row *ngIf="order.shipping && order.shipping.price > 0 && order.shipping.discount_rate < 100 && !shipping_refunded" class="quantity-row ion-align-items-start">
                                    
                                    
                                    <ion-col class="ion-align-self-center">
                                        <ion-grid class="ion-no-padding">
                                            <ion-row>
                                                <ion-col size="auto">
                                                    <h5>Item</h5>
                                                    <p class="prominent">Shipping<ng-container *ngIf="order.shipping_rate">: {{order.shipping_rate.title}}</ng-container></p>
                                                </ion-col>
                                            </ion-row>
                                        </ion-grid>
                                    </ion-col>

                                    <ion-col size="auto" class="ion-text-center">
                                        <div>
                                            <h5>Quantity</h5>
                                            <fa-icon size="lg" [icon]="['far', 'minus']" (click)="adjustShippingQuantity('subtract')"></fa-icon><span>{{shipping_quantity}}</span> of 1<fa-icon size="lg" [icon]="['far', 'plus']" (click)="adjustShippingQuantity('add')"></fa-icon>
                                        </div>
                                    </ion-col>
                                </ion-row>
                            </ion-grid>
                        </ion-col>
                    </ion-row>
                </ion-grid>

                <ion-grid class="fieldset">
                    <ion-row>
                        <ion-col>
                            <h3>Details</h3>
                        </ion-col>
                    </ion-row>
                    <ion-row>
                        <ion-col>
                            <ion-input *ngIf="params['date']" class="modal-input" readonly="true" label="Date" labelPlacement="stacked" fill="outline" value={{formatted_date}} (click)="presentDateTimePickerModal()"></ion-input>
                            <ion-input *ngIf="!params['date']" class="modal-input" readonly="true" label="Date" labelPlacement="stacked" fill="outline" (click)="presentDateTimePickerModal()"></ion-input>
                        </ion-col>
                    </ion-row>
                    <ion-row>
                        <ion-col>
                            <ion-textarea type="text" inputmode="text" maxlength="1000" [autoGrow]="true" rows="5" labelPlacement="stacked" fill="outline" [(ngModel)]="params['reason']">
                                <div slot="label">Reason<ion-text class="optional">optional</ion-text></div>
                            </ion-textarea>
                        </ion-col>
                    </ion-row>
                    <ion-row *ngIf="xero_connected">
                        <ion-col>
                            <ion-item lines="none" class="ion-no-padding">
                                <ion-toggle class="form-toogle" alignment="start" label-placement="stacked" [(ngModel)]="params['add_xero_credit_note']">Add Xero credit note</ion-toggle>
                            </ion-item>
                        </ion-col>
                    </ion-row>
                </ion-grid>
            </ion-col>
        </ion-row>
    </ion-grid>
</ion-content>